import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { motion } from 'framer-motion';

const courses = [
  { title: "Red Hat Enterprise Linux 9 (Full Course)", description: "RHEL 9 From Zero To Hero!", video: "https://www.youtube.com/embed/5UF37H3fwEY" },
  { title: "The Rocky Linux (Full Course)", description: "Rocky Enterprise Linux 9", video: "https://www.youtube.com/embed/WrItyCWtCFM" },
  { title: "The Complete Course To BASH Shell Scripting", description: "LINUX BASH Shell Scripting", video: "https://www.youtube.com/embed/PfSWC3CVMp0" },
  { title: "Linux Ubuntu (Full Course)", description: "Linux Ubuntu From Zero To Hero!", video: "https://www.youtube.com/embed/LBLiDCfb3yA" },
  { title: "The R Programming Language (Full Course)", description: "R Programming Language on Windows Platform", video: "https://www.youtube.com/embed/wst61AXPHRA" },
  { title: "Introduction to Oracle Sun Solaris VM", description: "Oracle Sun Solaris Virtual Machine", video: "https://www.youtube.com/embed/yUagQtKeEss" },
  { title: "Linux Fedora 39 Full Course", description: "Linux Fedora (From Zero To Hero!", video: "https://www.youtube.com/embed/MgjC2gPeHxo" },
  { title: "Mastering Visual Studio Code", description: "Mastering VS Code", video: "https://www.youtube.com/embed/9sed9X2zqY8" },
  { title: "Python Data Structures (String, Set, List, Tuple, List Comprehension, Data Dictionary, Class)", description: "Intro to Python Data Structure.", video: "https://www.youtube.com/embed/_tD-gLwTIBM" }
];

function Courses() {
  return (
    <>
    <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-800 dark:text-white transition">
      <Navbar />
      <div className="pt-24 px-6 max-w-4xl mx-auto">
        <br />
        <h2 className="text-2xl font-bold mb-6">Courses</h2>
        <div className="grid gap-6">
          {courses.map((course, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.2 }}
              className="p-4 border rounded-lg shadow-md dark:border-gray-700"
            >
           <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">{course.title}</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src={course.video}
            title={course.description}
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>

            </motion.div>
          ))}
        </div>
      </div>
    </div>
    { /*
        <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="pt-5"
      >
      </motion.div>
      */ }
          <div>
          <iframe
            className="w-full aspect-video rounded-lg shadow-lg"
            src="https://www.MyWebUniversity.com/cgi-bin/LUBE/LinuxOnline.cgi?cmd=cal" 
            title="Learn Linux OS For Free"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div>
          <iframe
            className="w-full aspect-video rounded-lg shadow-lg"
            src="https://www.MyWebUniversity.com/youtube-channels1w.html" 
            title="MyWebUniversity"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div>
          <iframe
            className="w-full aspect-video rounded-lg shadow-lg"
            src="https://www.MyWebUniversity.com/cgi-bin/LUBE/unixshells.cgi?cmd=cal" 
            title="Learn Linux Online For Free"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
    </>
  );
}
export default Courses;
